const reportsRouterLinks = {
  taxInvoiceReportsPage: '/reports/tax-invoice-report',
  profitAndLosesReportsPage: '/reports/profit-loses-report',
};

export default reportsRouterLinks;
